import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { installPreloadErrorBanner } from "./preload-error-banner";
import "./styles.css";

// Surface stale-chunk failures as a "tap to reload" banner instead of
// letting the user sit on a half-broken page when a deploy goes out
// mid-session. See preload-error-banner.ts for the why.
installPreloadErrorBanner();

const root = document.getElementById("root");
if (!root) throw new Error("#root element not found");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
